import React from "react";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col, CardImg} from "reactstrap";

const OrderItem = (props) => {
   
    return (
          <>
            <Col className="mb-2" xs="auto" xl="12" >
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center text-center">
                    <Col xs="2"></Col>
                    <Col xs="8">
                      <h3 className="mb-0" >{props.item.name} </h3>
                    </Col>
                    <Col className="text-right" xs="2">
                    <CardImg
                      style={{borderRadius: "5px"}}
                      alt="Card image cap"
                      src={'https://new.geticketsonline.com:9876/files/product-images/' + props.item.posterImage}
                      top
                      width="3%"
                    />
                    </Col>
                    
                  </Row>
                </CardHeader>
                <CardBody className="align-self-center text-center"  >
                  <Row>
                    <h3 className="mr-2">Date:{props.item.checkinFrom.split("T")[0]}</h3>
                    <h3>Time:{props.item.checkinFrom.slice(11,16)}</h3>
                  </Row>
                  <Row className=' text-center'>
                    <h3 className="mr-2">Quantity:{props.item.qt}</h3>
                    {props.item.bottle && <h3>Bottle: {props.item.bottle.map((bottleItem)=> bottleItem)}</h3>}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </>
                );
  
            }
            
            export default OrderItem;